import { Radio } from '@gassan-ui'
import { cn } from '@lib/cn'
import { motion } from 'framer-motion'
import React, { FC, useRef } from 'react'

type SortBackdropProps = {
  onRequestClose?: () => void
  onSortChange: (sort: string) => void
  sort: string
  sortOptions: { label: string; value: string }[]
}

const SortBackdrop: FC<SortBackdropProps> = ({
  onRequestClose,
  sort,
  onSortChange,
  sortOptions,
}) => {
  const ref = useRef<HTMLDivElement>()
  const handleBackdropClick = (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
    if (ref.current === e.target && onRequestClose) {
      onRequestClose()
    }
  }

  return (
    <motion.div
      ref={ref}
      onClick={handleBackdropClick}
      key="sort-backdrop"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.1 }}
      className="fixed inset-x-0 top-0 z-[1001] h-full w-full cursor-pointer bg-black/40"
    >
      <motion.div
        onClick={handleBackdropClick}
        initial={{ y: '100%' }}
        animate={{ y: 0 }}
        exit={{ y: '100%' }}
        transition={{ delay: 0.1, ease: 'easeOut', duration: 0.2 }}
        className={cn(
          'absolute bottom-0 z-[1] flex w-full cursor-default flex-col justify-end bg-white p-6 pb-[calc(env(safe-area-inset-bottom)+2.5rem)]',
          'sm:p-10 sm:pb-[calc(env(safe-area-inset-bottom)+5rem)]',
        )}
      >
        {sortOptions.map((option) => (
          <Radio
            name="sort"
            id={option.value}
            label={option.label}
            checked={sort === option.value}
            onChange={() => {
              onRequestClose()
              onSortChange(option.value)
            }}
          />
        ))}
      </motion.div>
    </motion.div>
  )
}

export default SortBackdrop
